export default __webpack_public_path__ + "static/media/profile.199f6217.jpg";